import { Box, Typography } from "@mui/joy";
import { ClassicyControlGroup } from "../../components/control-group/ClassicyControlGroup";
import "../styles/QuestionnaireSteps.css";

interface LocationSelectionStepProps {
  selectedLocation: string | null;
  locationOther: string;
  onSelect: (location: string) => void;
  onOtherChange: (value: string) => void;
}

const LOCATIONS = [
  { name: "School", displayName: "Schule" },
  { name: "Work/Office", displayName: "Arbeit/Büro" },
  { name: "Friend's home", displayName: "Bei Freunden" },
  { name: "My home", displayName: "Zuhause" },
  { name: "Library", displayName: "Bibliothek" },
  { name: "Internet café", displayName: "Internetcafé" },
];

function LocationSelectionStep({
  selectedLocation,
  onSelect,
}: LocationSelectionStepProps) {
  return (
    <Box className="questionnaire-step">
      <Typography level="h2" sx={{ mb: 3, textAlign: "center" }}>
        Woher kennst du ihn?
      </Typography>

      <ClassicyControlGroup label="Ort auswählen" columns={false}>
        <Box className="option-grid">
          {LOCATIONS.map((location) => (
            <button
              key={location.name}
              className={`option-button ${selectedLocation === location.name ? "selected" : ""}`}
              onClick={() => onSelect(location.name)}
            >
              {location.displayName}
            </button>
          ))}
        </Box>
      </ClassicyControlGroup>
    </Box>
  );
}

export default LocationSelectionStep;
